module.exports = __webpack_public_path__ + "static/media/springer_small_logo.02398e45.png";